/**
 * Le séparateur entre le contenu principal et un panneau ancré à droite.
 *
 * Un trait de 1 px et une zone de préhension de 4 px centrée dessus : c'est ce que
 * l'avocat voit et attrape entre sa conversation « Demander à Hector » et le reste
 * de l'écran. Les trois emplacements latéraux (assistant du dossier, canvas de
 * rédaction, aperçu pièces/jurisprudence) doivent s'attraper de la même façon —
 * d'où une définition unique ici plutôt qu'un jeu de classes recopié dans chaque
 * hôte, où ils avaient déjà divergé (le canvas portait une barre pleine de 1,5 px,
 * `bg-stone-200`).
 *
 * PAS de pastille au centre (2026-09-15) : les trois séparateurs en affichaient une
 * (`GripVertical` dans un carré), signalée comme un parasite visuel. Le curseur
 * `col-resize` au survol suffit à dire que le trait se tire.
 *
 * `touch-none` : sans lui, un drag au doigt sur la poignée fait défiler la page au
 * lieu de redimensionner — le geste est capturé par le navigateur avant nous.
 *
 * `relative` n'est pas décoratif : la zone de préhension est le pseudo-élément
 * `after`, positionné en absolu par rapport à ce trait. Un consommateur qui rend le
 * séparateur lui-même en absolu conserve donc un bloc conteneur valide.
 *
 * Deux consommateurs, parce qu'ils n'ont pas le même moteur de drag :
 *   • `ui/resizable.tsx` — les splits `react-resizable-panels` (dossier, canvas) ;
 *   • `DocumentPreviewPanel` — colonne en largeur px pilotée par `useEdgeResize`.
 * Seule l'apparence est partagée ; le geste reste propre à chacun.
 */
export const PANE_DIVIDER_CLASS =
  'relative w-px touch-none bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1';
